import * as Sentry from "@sentry/react";
// Add this button component to your app to test Sentry's error tracking
function ErrorButton() {
  return (
    <button
      onClick={() => {
        // Send a log before throwing the error
        Sentry.logger.info("User triggered test error", {
          action: "test_error_button_click",
        });
        throw new Error("This is your first error!");
      }}
    >
      Break the world
    </button>
  );
}
const ErrorTest = () => {
  return (
    <div className="relative flex h-screen justify-center flex-col items-center text-black bg-white dark:bg-black dark:text-white">
      <ErrorButton />
    </div>
  );
};

export default ErrorTest;
